import { components } from 'cng-web-lib'
import React from 'react'
import { useParams } from 'react-router-dom'
import SCOInvMgmtApiUrls from 'src/apiUrls/SCOInvMgmtApiUrls'
import pathMap from 'src/paths/PathMap_SCO_InvMgmt'
import FormProperties from './Buyer_FormProperties'
import BuyerTranslationText from './BuyerTranslationText'

const {
    form: {
        CngEditFormButtonSection
    },
    button: { CngSecondaryButton },
    CngGridItem
} = components

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification }) {
    const { id } = useParams()
    const translatedTextObject = BuyerTranslationText()

    return (

        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            shouldDisableEnterToSubmit
            showNotification={showNotification}
            history={history}
            bodySection={
                <FormProperties.Fields
                    disabled={false}
                    showNotification={showNotification}
                    id={id}
                />
            }
            renderButtonSection={() => (
                <CngEditFormButtonSection>
                    <CngGridItem>
                        <CngSecondaryButton
                            onClick={() => { history.push(pathMap.SCO_INV_BUYER_LIST) }}>
                            {translatedTextObject.cancel}
                        </CngSecondaryButton>
                    </CngGridItem>
                </CngEditFormButtonSection>
            )}
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{
                url: `${SCOInvMgmtApiUrls.GET_BUYER_BY_ID}`
            }}
            update={{
                url: SCOInvMgmtApiUrls.UPDATE_BUYER,
                successRedirect: pathMap.SCO_INV_BUYER_LIST
            }}
            id={id}
        />
    )

}

export default EditPage
